import React from 'react';

import './cinema-finder-loading.scss';

export const CinemaFinderLoading = (props) => (
    <div className={`cinema-finder__loading ${props.isDark ? 'is-dark' : ''}`}>
        <div className="cinema-finder__loading__spinner" />
    </div>
);
